// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("core.ruffle." + {"110":"c602a5994301686fe20a","993":"7a0ce5b4887d5c7f9b60"}[chunkId] + ".js");